<template>
  <div class="tkdetails full-height linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
      @click-left="$router.push({path:'/allOrder?findType=1'})"
    >
      <div style="display: flex">
        <div class="van-ellipsis van-ellipsis2">
          <span class="font12">{{ $t('F001', '订单号') }}：{{ details.orderNo }} &nbsp;{{ details.tripType|tripType }}</span>
        </div>
        <div>
          <span class="font12 pad-lf-10" style="color: #E2BC6F;" v-clipboard:copy="details.orderNo" v-clipboard:success="copySuc"
          >{{ $t('F626','复制单号') }}</span>
        </div>
      </div> 
    </ld-header>

    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="box">
          <travel-tips
            v-if="details.orderRangeBeanList[0]"
            :city-id="(details.orderRangeBeanList[0]?details.orderRangeBeanList[0].arriveCityId:'')"
          />
          <div class="head white ">
            <div class="font22 font-md fontTitle">
              <span>{{ details.orderStatusRemark }}</span>
              <van-tag
                v-if="'' != details.productColor && 3 == details.productType"
                :color="details.productColor"
                style="margin-right: 70px;"
                type="warning"
              >
                {{ details.productTag || "" }}
              </van-tag>
              <van-tag
                v-else
                type="warning"
              >
                {{ details.productTag || "" }}
              </van-tag>
              <ld-email-popup
                v-if="details.id && !isYlslh5"
                :id="details.id"
                :djlx="details.orderType"
                :order-no="details.orderNo"
              />
            </div>
            <div>{{ $t('F002', '预订时间') }}：{{ details.bookDate }}</div>
            <div>{{ $t('F003', '预订人') }}：{{ details.bookerName }}</div>
            <div
              v-if="li"
              class="daojishi"
            >
              <span
                v-if="false"
                style="color: #fff;display: flex;"
              >剩余:{{ msg }}</span>
            </div>
          </div>
          <div
            v-for="(item,index) in details.orderRangeBeanList"
            :key="item.id"
            class="planeBox"
          >
            <div
              v-if="0"
              class="xc"
            >
              <span>第{{ lcname }}程</span>
            </div>
            <voyage
              :ccsqd-id="details.ccsqdId"
              :flight="item"
              :index="index"
              :show-car="showCar"
              :show-rule="true"
            >
              <van-tag
                v-if="details.isyw == 1"
                slot="tag-less"
                plain
                type="danger"
              >
                {{ $t('F620', '延误/取消') }}
              </van-tag>
            </voyage>
          </div>
          <div class="planeBox">
            <van-cell>
              <traver
                :add-button="false"
                :disabled="true"
                :title="$t('C001','乘机人')"
                :traveler-list="details.orderPsgBeanList"
              />
            </van-cell>
          </div>
          <!-- 保险 -->
          <insurance
            v-if="details.id"
            :check-bx-list.sync="checkBxList"
            :cplx="cplx"
            :cxrlength="details.orderPsgBeanList.length"
            :order-id="details.id"
            class="m-b-5"
            element=".tkdetails"
          />
          <!-- 退 -->
          <div
            v-for="r in refund"
            :key="r.refundId"
            class="m-b-5"
            @click="$router.push({path:'/tk/tkRefundDetail?orderId='+r.refundId})"
          >
            <div
              v-for="g in r.refundRangeList"
              :key="g.rangeId"
            >
              <voyage :flight="g">
                <!-- :show-rule="flightItem.newChange?true:false" -->
                <van-tag
                  slot="tag"
                  type="danger"
                >
                  <span>{{ $t('H117', '退') }}</span>
                </van-tag>
                <span slot="right">{{ r.refundStatusRemark }}</span>
              </voyage>
            </div>
          </div>
          <!-- 改 -->
          <div
            v-for="(el,dtindex2) in change"
            :key="dtindex2"
            class="m-b-5"
            @click="$router.push({path:'/tk/tkChangeDetail?orderId='+el.changeId})"
          >
            <div
              v-for="(p,dtindex3) in el.rangeList"
              :key="dtindex3"
            >
              <voyage
                :ccsqd-id="details.ccsqdId"
                :flight="p"
                :show-car="true"
              >
                <!-- :show-rule="flightItem.newChange?true:false" -->
                <van-tag
                  slot="tag"
                  type="warning"
                >
                  <span>改</span>
                </van-tag>
                <span slot="right">{{ el.changeAmount }}</span>
              </voyage>
            </div>
          </div>

          <!-- 差旅信息 -->
          <div v-if="details.tripType==1">
            <div class="planeBox">
              <travel-info
                ref="travelinfo"
                :details="true"
                :travel-data="details"
              />
            </div>
            <div
              v-if="details.vipStatus != 4"
              class="planeBox"
            >
              <!-- 审批规则 -->
              <approval
                :isssbz="details.isShowApproval!='1'"
                :order-id="details.id"
                :order-type="details.orderType"
                :spgz-id="details.appId"
                :ssbz="details.ccsqdRemark"
                :vip-status="details.vipStatus"
                element=".tkdetails"
              />
            </div>
            <ld-uploader
              v-if="details.id"
              :cjlx="2"
              :glywlx="details.orderType"
              :order-id="details.id"
              :order-status="details.orderStatus"
              class="mt5 round-sm overflow"
            />
          </div>
          <div
            v-show="airlineData.qrCodeUrl && showqrCodbox"
            class="qrCodbox"
          >
            <img :src="airlineData.qrCodeUrl">
            <p>{{ airlineData.title }}</p>
          </div>
        </div>
      </mescroll-vue>
    </div>

    <ld-tabbar
      ref="tabbar"
      :price-list="pricelistNew"
      class="bg-white shadow"
    >
      <van-row
        align="center"
        class="full-width pad-lr-10"
        gutter="8"
        type="flex"
      >
        <van-col span="10">
          <div class="font10 gray">
            {{ $t('E017', '共') }}
            {{ details.orderPsgBeanList.length }}
            {{ $t('E113', '人') }}
          </div>
          <span class="font12 money-color">&yen; </span>
          <span class="font22 money-color"> {{ details.totalPrice + Number(this.cr + this.er || 0) }}</span>
          <span
            class="font12 text-center"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006', '明细') }}</span>
            <van-icon
              class="vertical-middle"
              name="arrow-up"
              size="14"
            />
          </span>
        </van-col>
        <van-col span="14">
          <van-row
            gutter="8"
            justify="end"
            type="flex"
          >
            <van-col
              v-if="details.isShowCancel==1"
              span="8"
            >
              <ld-button
                defaults
                size="md"
                @click.native="btnClick('cancel')"
              >
                {{ $t('B008', '取消') }}
              </ld-button>
            </van-col>

            <van-col
              v-if="details.isShowCancelApproval==1"
              span="8"
            >
              <ld-button
                defaults
                size="md"
                @click.native="btnClick('revertApproval')"
              >
                {{ $t('B065', '撤回') }}
              </ld-button>
            </van-col>

            <van-col
              v-if="details.isShowEndorse==1 && details.international==1 && $store.state.tr.subsequent.changeshow"
              span="8"
            >
              <ld-button
                defaults
                size="md"
                @click.native="btnClick('change')"
              >
                {{ $t('B034', '改签') }}
              </ld-button>
            </van-col>

            <van-col
              v-if="details.isShowRefund==1 && details.international==1 && $store.state.tr.subsequent.refundshow"
              span="8"
            >
              <ld-button
                defaults
                size="md"
                @click.native="btnClick('refund')"
              >
                {{ $t('B035', '退票') }}
              </ld-button>
            </van-col>
            <van-col
              v-if="details.isShowApproval==2"
              span="8"
            >
              <ld-button
                main
                size="md"
                @click.native="btnClick('sendApproval')"
              >
                {{ $t('Submit', '再送审') }}
              </ld-button>
            </van-col>
            <van-col
              v-if="details.isShowApproval==1"
              span="8"
            >
              <ld-button
                main
                size="md"
                @click.native="btnClick('sendApproval')"
              >
                {{ $t('B028', '送审') }}
              </ld-button>
            </van-col>
            <van-col
              v-if="details.isShowPay==1"
              span="8"
            >
              <ld-button
                main
                size="md"
                @click.native="btnClick('pay')"
              >
                {{ $t('B014', '支付') }}
              </ld-button>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </ld-tabbar>


    <!--支付  -->
    <!-- <ld-pay
      ref="pay"
      @selected="pay"
      :order-type="details.orderType"
      :order-id="details.id"
    /> -->
  </div>
</template>

<script>
import ldButton from 'Common/ldButton'
import voyage from 'Views/Tk/tkQuery/roundtrip/voyage/voyage'
import traver from 'Components/tk/traver'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import travelInfo from 'Components/travelInfo'
import insurance from 'Views/Tk/tkQuery/roundtrip/insurance/index'
import approval from 'Components/approval/approval'
import MescrollVue from 'mescroll.js/mescroll.vue'
import {Cell, Tag, Popup, Toast} from 'vant'
import {changeData} from 'Views/Tk/tkChange/utils'
import Business from '@/business/utils/business'
import travelTips from 'Components/travelTips'
import ldUploader from 'Components/ldUploader'
import ldEmailPopup from 'Components/LdEmailPopup'
import defaultMixin from '@/business/mixins/default'
import {queryVipParameter} from 'Utils/publicApi'
import { isGat, toPayForGat } from 'Utils/gattools';

export default {
  name: 'TkDetail',
  mixins: [defaultMixin],
  components: {
    ldButton,
    voyage,
    ldTabbar,
    travelInfo,
    MescrollVue,
    insurance,
    traver,
    approval,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    travelTips,
    ldUploader,
    ldEmailPopup
  },
  data() {
    return {
      cr: '',
      er: '',
      Passengers: [],
      li: true,
      creatime: '', // 开始时间
      daoTim: '',  // 倒计时时间
      msg: '',
      djs: '',
      time1: true,
      lcname: '',
      down: {use: false},
      details: {
        orderPsgBeanList: [],
        orderRangeBeanList: []
      },
      order: {},
      checkBxList: [],
      refund: [],
      change: [],
      airlineData: {}, //航司信息
      showCar: true,
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isLdentifying: {
      type: String,
      default: ''
    },
    showqrCodbox: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    orderId() {
      return this.$route.query.orderId || this.id
    },
    pricelistNew() {
      let adts = []
      let chds = []
      let coupon = {}

      if (this.details.orderPsgBeanList && this.details.orderPsgBeanList.length > 0) {
        this.details.orderPsgBeanList.forEach(p => {
          console.log(p)
          if (p.psgType === 1) {
            adts.push(p)
            this.cr = Number(adts[0].bxPrice * adts.length) || 0//成人
          } else if (p.psgType === 2) {
            chds.push(p)
            this.er = Number(chds[0].bxPrice * chds.length) || 0//儿童
          }
        })
        var BX = {
          cr: this.cr,
          er: this.er,
        }
        sessionStorage.setItem('BX', JSON.stringify(BX))//储存保险价格
      }
      if (this.details.obtBookCoupon) {
        coupon = this.details.obtBookCoupon
      }
      var bx = JSON.parse(sessionStorage.getItem('BX'))//获取保险的价格
      const priceList = [{
        type: 'spliter',
        name: '-------- ' + this.$t('C115', '成人') + ' --------',
        price: null,
        amount: null,
        unit: '',
        show: adts.length > 0,
        hideYen: true
      },
      {
        type: 'adtP',
        name: this.$t('C115', '成人'),
        price: adts[0] && adts[0].salePrice + adts[0].airportFee + adts[0].tax + adts[0].serviceFee + Number(adts[0].bxPrice || 0),
        amount: adts.length,
        unit: '/' + this.$t('E113', '人'),
        show: adts.length > 0
      }, {
        type: 'adtP',
        name: this.$t('C1150', '票面'),
        price: adts[0] && adts[0].salePrice,
        // amount: this.Passengers.length,
        unit: '/' + this.$t('E113', '人'),
        show: adts.length > 0
      },
      {
        type: 'adtCN',
        name: this.$t('E102', '机建') + '  (' + '共' + this.details.orderRangeBeanList.length + '程' + ')',
        price: adts[0] && adts[0].airportFee,
        // amount: adts.length,
        unit: '/' + this.$t('E113', '人'),
        show: adts.length > 0
      }, {
        type: 'adtYQ',
        name: this.$t('E103', '燃油税') + '  (' + '共' + this.details.orderRangeBeanList.length + '程' + ')',
        price: adts[0] && adts[0].tax,
        // amount: adts.length,
        unit: '/' + this.$t('E113', '人'),
        show: adts.length > 0
      }, {
        type: 'chdFW',
        name: '服务费',
        price: adts[0] && adts[0].serviceFee,
        // amount: adts.length,
        unit: '/人',
        show: adts.length > 0
      },
      {
        type: 'chdBX',
        name: this.$t('E505', '保险') + '  (' + '共' + this.details.orderRangeBeanList.length + '程' + ')',
        price: adts[0] && adts[0].bxPrice,
        // amount: `/ ${adts.length}份`,
        unit: '',
        show: this.bxPrice > 0 && adts.length > 0
      }
      , {
        type: 'spliter',
        name: '-------- ' + this.$t('C116', '儿童') + ' --------',
        price: null,
        amount: null,
        unit: '',
        show: chds.length > 0,
        hideYen: true
      },
      {
        type: 'chdP',
        name: this.$t('C116', '儿童'),
        price: chds[0] && chds[0].salePrice + chds[0].tax + adts[0].serviceFee + Number(chds[0].bxPrice || 0),
        amount: chds.length,
        unit: this.$t('E113', '人'),
        show: chds.length > 0
      }, {
        type: 'chdP',
        name: this.$t('C1150', '票面'),
        price: chds[0] && chds[0].salePrice,
        // amount: chds.length,
        unit: this.$t('E113', '人'),
        show: chds.length > 0
      }, {
        type: 'chdCN',
        name: this.$t('E102', '机建') + '  (' + '共' + this.details.orderRangeBeanList.length + '程' + ')',
        price: 0,
        // amount: chds.length,
        unit: '/' + this.$t('E113', '人'),
        show: chds.length > 0
      }, {
        type: 'chdYQ',
        name: this.$t('E103', '燃油税') + '  (' + '共' + this.details.orderRangeBeanList.length + '程' + ')',
        price: chds[0] && chds[0].tax,
        // amount: chds.length,
        unit: '/' + this.$t('E113', '人'),
        show: chds.length > 0
      },
      {
        type: 'chdFW',
        name: '服务费',
        price: adts[0] && adts[0].serviceFee,
        // amount:chds.length,
        unit: '/人',
        show: chds.length > 0
      },
      {
        type: 'chdBX',
        name: this.$t('E505', '保险') + '  (' + '共' + this.details.orderRangeBeanList.length + '程' + ')',
        price: chds[0] && chds[0].bxPrice,
        // amount: `/ ${chds.length}份`,
        unit: '',
        show: this.bxPrice > 0 && chds.length > 0
      }, {
        type: 'adtP',
        name: this.$t('E003', '优惠劵'),
        price: coupon && coupon.amount,
        // amount: 1,
        unit: '',
        show: coupon.amount > 0
      }]
      return priceList
    },
    cplx() {
      return this.details.international == 0 ? '10902' : '10901'
    }
  },
  mounted() {
    queryVipParameter('1221').then(res => {
      setTimeout(() => {
        this.creatime = this.details.bookDate   // 下单开始的时间
      }, 1000)
      this.daoTim = res.value1  // 过期时间  15分钟 或者30分钟
      setInterval(this.countdown, 1000)   // 调用倒计时
      res.value1 // 根据value1返回的分钟数 页面展示倒计时
    })
    if (this.msg = '') {
      this.time1 = false
    }
  },
  updated() {
    this.creatime = this.details.bookDate
    if (this.details.orderStatusRemark == '待支付') {
      this.li = true
    } else {
      this.li = false
    }
  },
  async created() {
    if (this.orderId) {
      this.getDetail()
      this.getRefund()
      this.getChange()
    } else if (this.$route.query.order) {
      this.order = this.$route.query.order
    }
    setTimeout(() => {
      const filteredArr = this.details.orderPsgBeanList.filter((item, index, self) => {
        return !index || !self.slice(0, index).some(({psgName}) => psgName === item.psgName)
      })
      this.Passengers = filteredArr//乘机人过滤
      console.log(filteredArr)
      console.log(this.Passengers, '乘机人')
    }, 1000)
  },
  methods: {
    //复制订单号
    copySuc() {
      return this.$toast({
        message: this.$t('F627', '复制成功'),
        type: 'success'
      })
    },

    async asyncFunc() {
      let result = await new Promise(() => {
        setTimeout(() => {
          var st = JSON.parse(sessionStorage.getItem('objp'))
          if (st[0].orderNo == this.details.orderNo ? true : false) {
            this.lcname = '1'
          } else if (st[1].orderNo == this.details.orderNo ? true : false) {
            this.lcname = '2'
          }
        }, 1000)
      })
    },
    btnClick(name) {
      console.log(this)
      let self = this
      let obj = {
        cancel() {//取消
          self.$dialog.confirm({
            message: '是否取消订单'
          }).then(() => {
            self.$api['tkOrder/cancelTkOrder']({
              orderId: self.orderId
            }).then(() => {
              self.$toast('订单已取消')
              self.getDetail()
            })
          })
        },
        sendApproval() {//送审
          self.details.orderType = $dict.ORDER_TYPE.tk.normal
          Business.ApprovalSend(self.details, () => {
            self.getDetail()
          })
        },
        async revertApproval() { // 撤回
          await Business.ApprovalRevert(self.details)
          self.getDetail()
        },
        refund() {//退票
          self.$router.push({path: '/tk/wfRefundApply', query: {orderId: self.details.id, GoBack: true}})
        },
        change() {//改签
          self.$router.push({path: '/tk/wfChangeApply', query: {orderId: self.details.id, GoBack: true}})
        },
        pay() {//支付
          // self.toggle('pay')
          if (self.li == false) {
            Toast('订单已取消')
          } else {
            if (isGat()) {
              return toPayForGat(self.details.id, self.details.orderType)
            }
            self.$router.push({
              path: '/pay/payment',
              query: {orderType: self.details.orderType, orderId: self.details.id}
            })
          }
        }

      }

      name && obj[name] && obj[name]()
    },
    pay() {
      // this.getDetail()
    },
    getDetail() {
      this.$api['tkOrder/orderDetail']({
        id: this.orderId
      }).then(res => {
        let cache = res.data || {}
        this.bxPrice = cache.bxPrice
        if (this.isLdentifying) {
          let index = cache.orderStatusRemark.indexOf('|')
          cache.orderStatusRemark = cache.orderStatusRemark.substr(0, index + 1) + '确认中'
        }
        this.details = cache
        this.getFindByAirline()
      }).catch(res => {
        this.$toast(res.errMsg)
      })
    },
    getFindByAirline() {
      this.$api['tkOrder/findByAirline']({
        airline: this.details.airline
      }).then(res => {
        this.airlineData = res.data || {}
      }).catch(res => {
        this.$toast(res.errMsg)
      })
    },
    getRefund() {
      this.$api['tkOrder/moreRefundInfo']({
        orderId: this.orderId
      }).then(res => {
        this.refund = res.data || []
      }).catch(res => {
        this.$toast(res.errMsg)
      })
    },
    getChange() {
      this.$api['tkOrder/findChangeOrderByOrderId']({
        orderId: this.orderId
      }).then(res => {
        let range = res.data || []
        if (range.length > 0) {
          range.forEach(el => {
            let rangeList = changeData(el.rangeList)
            var arr = []
            rangeList.forEach(item => {
              if (item.newChange) {
                arr.push(item)
              }
            })
            el.rangeList = arr
          })
          this.change = range
          this.showCar = false
        }
      }).catch(res => {
        this.$toast(res.errMsg)
      })
    },
    toggle(ref) {
      this.$refs[ref].toggle()
    },
    countdown() {
      var _that = this
      var now = new Date(_that.creatime.replace(/-/g, '/'))  //处理开始时间    这个方法兼容大多数浏览器以及h5手机端
      var minutes = Number(_that.daoTim)  //处理输入的过期时间
      var end = now.setMinutes(now.getMinutes() + minutes) //计算最后时间
      var time_now = new Date().getTime() //当前时间
      var msec = end - time_now   //最后时间-当前时间
      if (msec > 0) {
        let day = parseInt(msec / 1000 / 60 / 60 / 24)
        let hr = parseInt(msec / 1000 / 60 / 60 % 24)
        let min = parseInt(msec / 1000 / 60 % 60)
        let sec = parseInt(msec / 1000 % 60)
        day = day
        hr = hr > 9 ? hr : '0' + hr
        min = min > 9 ? min : '0' + min
        sec = sec > 9 ? sec : '0' + sec,
        this.msg = min + '分' + sec + '秒'
      } else {
        clearInterval(tim)
        if (_that.min == '0' && _that.sec == '0') {
          this.li = true
        } else {
          this.li = false
        }
      }
      const that = this
      var tim = setTimeout(function () {
        that.countdown(_that.creatime, _that.daoTim)
      }, 1000)
    },
  },
  filters: {
    tripType(val) {
      return val == 1 ? '公' : '私'
    }
  }
}
</script>

<style lang="less" scoped>
@import "~Assets/styles/business.less";

.fontTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .dowPdf {
    font-size: 16px;
  }
}

.tkdetails {

  .box {
    padding: 0 8px 50px;

    .head {
      padding: 0.3rem 0.2rem 0.4rem;
    }
  }

  .planeBox {
    padding-bottom: 5px;
  }
}

.pad-5 {
  padding: 5px;
}

.pad-lr-10 {
  padding: 0 10px;
}

.pad-lf-10 {
  padding-left: 10px;
}

.m-b-5 {
  margin-bottom: 5px;
}

.wrapper {
  height: calc(100vh - 96px);
  overflow: hidden;
}

.qrCodbox {
  margin-top: 5px;
  padding: 10px;
  width: 100%;
  height: auto;
  background: white;
  text-align: center;

  img {
    width: 130px;
    height: 130px;
    margin: 20px 0;
    background: black;
  }

  p {
    font-weight: 900;
    font-size: 18px;
  }
}

.xc {
  width: 44px;
  height: 20px;
  line-height: 20px;
  background-image: linear-gradient(-90deg, #45bf9b 0%, #52dcb3 100%), linear-gradient(#eef2f7, #eef2f7);
  background-blend-mode: normal, normal;
  box-shadow: 0px 2px 2px 0px rgba(51, 164, 131, 0.3);
  border-radius: 5px;
  text-align: center;

}

::v-deep .van-ellipsis {
  overflow: inherit;
}
.van-ellipsis2 {
  overflow: hidden;
}
::v-deep .van-nav-bar__title {
  max-width: 75%;
}
</style>
